<button
  type="button"
  class="notificaciones-fab"
  [class.is-ready]="posicionLista"
  [class.is-dragging]="arrastrando"
  [style.left.px]="posicionX"
  [style.top.px]="posicionY"
  (pointerdown)="iniciarArrastre($event)"
  (click)="alternarPanel($event)"
  [attr.aria-expanded]="panelAbierto"
  aria-controls="panel-notificaciones"
  aria-label="Abrir notificaciones. Mantén y arrastra para mover"
  title="Notificaciones · Arrastra para mover"
>
  <i class="material-icons" aria-hidden="true">notifications_none</i>
  <span *ngIf="contador > 0" class="notificaciones-badge">
    {{ contador > 99 ? '99+' : contador }}
  </span>
</button>

<section
  *ngIf="panelAbierto"
  #panelNotificaciones
  id="panel-notificaciones"
  class="notificaciones-panel"
  [style.left.px]="panelX"
  [style.top.px]="panelY"
  (click)="$event.stopPropagation()"
  aria-label="Bandeja de notificaciones"
>
  <header class="panel-header">
    <div>
      <div class="panel-title">Notificaciones</div>
      <div class="panel-subtitle">Avisos de la empresa activa</div>
    </div>
    <button
      type="button"
      class="panel-close"
      (click)="panelAbierto = false"
      aria-label="Cerrar notificaciones"
    >
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
  </header>

  <div class="panel-toolbar">
    <div class="filter-pills" aria-label="Filtros de notificaciones">
      <button
        type="button"
        class="filter-pill"
        [class.active]="estado === 'TODAS'"
        (click)="cambiarEstado('TODAS')"
      >
        Todas
      </button>
      <button
        type="button"
        class="filter-pill"
        [class.active]="estado === 'NO_LEIDAS'"
        (click)="cambiarEstado('NO_LEIDAS')"
      >
        Pendientes
        <span *ngIf="contador > 0">{{ contador }}</span>
      </button>
    </div>

    <button
      type="button"
      class="mark-all"
      [disabled]="!contador || cargandoAccion"
      (click)="marcarTodas()"
    >
      Marcar leídas
    </button>
  </div>

  <div class="panel-content">
    <div *ngIf="cargandoLista && !items.length" class="panel-loading">
      <div class="panel-spinner"></div>
      <span>Consultando notificaciones...</span>
    </div>

    <div *ngIf="errorLista && !items.length" class="panel-error">
      <span>{{ errorLista }}</span>
      <button type="button" (click)="cargarPrimeraPagina()">Reintentar</button>
    </div>

    <div
      *ngIf="!cargandoLista && !errorLista && !items.length"
      class="panel-empty"
    >
      <span class="empty-icon">
        <i class="material-icons" aria-hidden="true">notifications_none</i>
      </span>
      <strong>Todo está al día</strong>
      <span>No tienes notificaciones para mostrar.</span>
    </div>

    <article
      *ngFor="let item of items"
      class="notification-item"
      [class.is-unread]="!item.fechaLectura"
      [class.has-route]="item.rutaFrontend"
      (click)="seleccionar(item)"
    >
      <span class="level-icon" [ngClass]="'level-' + item.nivel.toLowerCase()">
        <i class="material-icons" aria-hidden="true">{{ iconoNivel(item) }}</i>
      </span>

      <div class="notification-copy">
        <div class="notification-heading">
          <strong>{{ item.titulo }}</strong>
          <span *ngIf="!item.fechaLectura" class="unread-dot" title="No leída"></span>
        </div>
        <p>{{ item.mensaje }}</p>
        <span class="notification-date">
          {{ item.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
        </span>
      </div>

      <button
        type="button"
        class="archive-button"
        (click)="archivar(item, $event)"
        [disabled]="cargandoAccion"
        aria-label="Archivar notificación"
        title="Archivar"
      >
        <i class="material-icons" aria-hidden="true">archive</i>
      </button>
    </article>

    <button
      *ngIf="tieneMas()"
      type="button"
      class="load-more"
      [disabled]="cargandoLista"
      (click)="cargarMas()"
    >
      {{ cargandoLista ? 'Cargando...' : 'Ver más notificaciones' }}
    </button>
  </div>
</section>
